module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7PimQL/tc-custom/9781460322680.jpg?1728327053856",
      "alt": "This image is the cover for the book Not Just the Boss's Plaything & A Devil in Disguise"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Not Just the Boss's Plaything & A Devil in Disguise\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Not Just the Boss's Plaything "), _c('br'), _c('br'), _vm._v("A very personal performance plan  "), _c('br'), _c('br'), _vm._v("From the moment Alicia Teller tripped and fell into Nikolai Korovin's arms, her iron-clad control started to slip! "), _c('br'), _c('br'), _vm._v("While Alicia's tantalizing curves might drive Nikolai to distraction, business and pleasure are not two things this legendary tycoon has ever mixeduntil now. "), _c('br'), _c('br'), _vm._v("A Devil in Disguise "), _c('br'), _c('br'), _vm._v("Playing with fire! "), _c('br'), _c('br'), _vm._v("Drusilla Bennett's job from hell will soon be over. Ready to take her life back, she plucks up the courage to say \"I quit!\" "), _c('br'), _c('br'), _vm._v("But nothing and no one has ever taken Cayo Vila by surprise, and he's not going to let Dru go quite so easily!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caitlin Crews\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Caitlin Crews discovered her first romance novel at the age of twelve and has since began her life-long love affair with romance novels, many of which she insists on keeping near her at all times. She currently lives in California, with her animator/comic book artist husband and their menagerie of ridiculous animals.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0